const initialState = 'signin'; //should we show sign-in component ? (answer ... initialState )

const loginPageHandler = ( state = initialState, action) => {
    switch(action.type){
        case 'HANDLE_PAGE_TOGGLE':
            state = action.payload.alignment;
            return state;
            
        default :
            return state;
    }
};

export default loginPageHandler;